export default "__VITE_ASSET__CpaA_fuw__"